class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.expiresDate = Number(this.getAttribute('data-expire')) || 30;
    this.closeButton = this.querySelector('[data-close-newsletter-popup]');
    this.form = this.querySelector('#ContactPopup');
    this.closeButton?.addEventListener('click', () => this.close());
    this.form?.addEventListener('submit', () => this.dismiss());
    this.addEventListener('click', e => e.stopPropagation());
    this.onExit = this.onExit.bind(this);
    this.onOutsideClick = this.onOutsideClick.bind(this);
    if (!this.getCookie('newsletter-popup') && window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)').matches && !location.pathname.startsWith('/checkouts') && !location.pathname.startsWith('/checkout') && !location.pathname.startsWith('/cart')) {
      setTimeout(() => { document.addEventListener('mouseout', this.onExit); }, 8000);
    }
  }
  getCookie(name) {
    return document.cookie.split('; ').find(x => x.startsWith(name + '='))?.split('=')[1] || '';
  }
  dismiss() {
    const until = new Date(Date.now() + this.expiresDate * 86400000).toUTCString();
    document.cookie = 'newsletter-popup=closed; expires=' + until + '; path=/; SameSite=Lax';
    document.removeEventListener('mouseout', this.onExit);
  }
  onExit(event) {
    if (event.relatedTarget || event.toElement || event.clientY > 0 || this.getCookie('newsletter-popup')) return;
    if (document.body.classList.contains('cart-sidebar-show') || document.body.classList.contains('quick-view-show')) return;
    document.body.classList.add('newsletter-show');
    document.body.classList.add('show-newsletter-image');
    document.removeEventListener('mouseout', this.onExit);
    setTimeout(() => document.addEventListener('click', this.onOutsideClick), 0);
  }
  onOutsideClick(event) { if (!this.contains(event.target)) this.close(); }
  close() {
    this.dismiss();
    document.body.classList.remove('newsletter-show','show-newsletter-image');
    document.removeEventListener('click', this.onOutsideClick);
  }
}
if (!customElements.get('newsletter-popup')) customElements.define('newsletter-popup', NewsletterPopup);
class NewsletterMessagePopup extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[data-close-newsletter-message-popup]')?.addEventListener('click', () => this.close());
    document.body.addEventListener('click', e => { if (!this.contains(e.target)) this.close(); });
  }
  close() { document.body.classList.remove('newsletter-message-show'); }
}
if (!customElements.get('newsletter-message-popup')) customElements.define('newsletter-message-popup', NewsletterMessagePopup);
